import Error404Page from "./Error404Page";

export default Error404Page;
